import { useCallback } from 'react';
import { useMap } from 'react-leaflet';

interface UseMapControllerProps {
    markerPosition?: [number, number];
}

export const useMapController = ({ markerPosition }: UseMapControllerProps) => {
    const map = useMap();

    const handleZoomIn = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (map) {
            map.zoomIn(1);
        }
    }, [map]);

    const handleZoomOut = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (map) {
            map.zoomOut(1);
        }
    }, [map]);

    const handleCenterOnMarker = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (markerPosition && map) {
            map.setView(markerPosition, map.getZoom(), {
                animate: true,
                duration: 0.5
            });
        }
    }, [map, markerPosition]);

    return {
        handleZoomIn,
        handleZoomOut,
        handleCenterOnMarker
    };
}; 